export default {
  'u.header.exchange': '交易所',
  'u.header.myinvest': '投资状况',
  'u.header.wallet': '存取款',
  'u.header.mypage': '我的主页',
  'u.header.cscenter': '客服中心',
  'u.header.login': '登录',
  'u.header.logout': '退出',
  'u.header.signup': '注册会员',
  'u.header.hello_message': 'Hello, <span class="name">{name}</span>',

  'u.login.login': '登录',
  'u.login.email': '邮箱',
  'u.login.password': '密码',
  'u.login.check_exchange_address':
    'Please check that you are visiting website that address is same as below.',
  'u.login.please_proceed_recaptcha': 'Please proceed CAPTCHA verification.',
  'u.login.alert.please_enter_email': 'Please enter email.',
  'u.login.alert.invalid_email': 'Invaild Email address.',
  'u.login.alert.please_enter_password': 'Please enter password.',

  'u.mypage.kyc.passport': '护照',
  'u.mypage.kyc.id_card': '身份证',
  'u.mypage.kyc.driver_card': '驾照',
  'u.mypage.kyc.name': '姓名',
  'u.mypage.kyc.first_name': '名',
  'u.mypage.kyc.last_name': '姓',
  'u.mypage.kyc.select': '选择',
  'u.mypage.kyc.mobile_number': '手机号码(Only Number)',
  'u.mypage.kyc.passport_number': '护照号码',
  'u.mypage.kyc.id_card_number': '身份证号码',
  'u.mypage.kyc.driver_card_number': '驾照号码',
  'u.mypage.kyc.region': '各国家、地区发行文件',
  'u.mypage.kyc.expire_date': '到期日',
  'u.mypage.kyc.issue_date': '发行日',
  'u.mypage.kyc.upload_image': '上传图片',
  'u.mypage.kyc.upload': '上传',
  'u.mypage.kyc.modify': '修改',
  'u.mypage.kyc.delete': '删除',
  'u.mypage.kyc.country': '国家',
  'u.mypage.kyc.city': '城市',
  'u.mypage.kyc.address': '地址',
  'u.mypage.kyc.postcode': '邮政编码',
  'u.mypage.kyc.upload_image_example': '图片上传示例',
  'u.mypage.kyc.upload_image_example_description':
    '选择驾照或身份证的正面，可与备忘录同时上传。请提供手持身份证的照片。在同一图片中应显示{hostname}和今天日期。面部应清晰可见，可清楚地识别身份证的所有详细事项。',
  'u.mypage.kyc.ok': '完成',
  'u.mypage.kyc.please_hide_some_number':
    '上传认证照片时，请务必按照示例照片遮住数字部分后发送。',
  'u.mypage.kyc.please_upload_file_size_below_5mb': '请上传5MB以下的文件。',

  hello: '您好',
  coin_search_placeholder: '查找货币名称、标志',
  coin_name: '货币名称',
  coin_list_loading: '正在加载货币目录。',
  there_is_no_coin: '市场中没有您查找的货币。',
  now_price: '现在价格',
  compare_yesterday: '对比昨日',
  trade_volume: '交易量(24小时)',
  my_balances: '我持有的资产',
  holding_coin: '持有货币',
  total_balances_cash: '持有现金',
  total_balances: '总持有资产',
  total_buying: '总购买',
  total_valuation: '总评价',
  profit_amount: '评估损益',
  profit_rate: '收益率',
  notice: '通知事项',
  notice_short: '通知',
  notice_loading: '正在加载通知事项。',
  there_is_no_notice: '无通知事项。',
  company: '公司简介',
  guide: '使用指南',
  terms: '使用条约',
  privacy: '个人信息处理方针',
  kakaotalk: 'kakaotalk咨询(24小时)',
  account_support: '账号、使用咨询',
  wallet_support: '存取款、其他咨询',
  'common.loading': '加载中......',
  'common.please_login': '请在<span class="name">登录</span>后使用。',
  'common.empty': '无显示内容。',
  'common.million': '百万',
  'menu.exchange': '交易所',
  'menu.myinvest': '投资状况',
  'menu.wallet': '存取款',
  'menu.mypage': '我的主页',
  'menu.cscenter': '客服中心',
  'menu.login': '登录',
  'menu.logout': '退出',
  'menu.signup': '注册会员',
  'menu.uio_announcement': '公告',
  'main.banner.phrase1': '与全新的IEX GLOBAL见面吧!',
  'main.banner.phrase2':
    'IEX GLOBAL EXCHANGE为加密货币交易提供最佳的用户体验。',
  'main.banner.phrase3':
    '是通过海外IEX合作伙伴在中国、泰国、越南、印度尼西亚等<br />全世界交易所运营的世界首家国际交易所。',
  'main.notice': '通知事项',
  'main.is_logged_in': '您已登录。',
  'main.no_notice': '无通知事项。',
  'main.uio_explain': '按照交易额支付IEXCO开采货币!',
  'main.contribute_cash_explain': '按照奉献度支付IEXCO现金!',
  'main.cash_can_be_charged_with_platform':
    '用合作平台的现金可购买加密货币，现金也可以在合作平台中使用。',
  'main.platform_point_to_cash': '在合作平台中转换为现金',
  'main.uioex_wallet': '加密货币IEX WALLET',
  'main.uioex_exchange': 'IEX加密货币交易所',
  'main.uioex_features': 'IEX特征',
  'main.transparency': '透明性',
  'main.transparency_explain': '90%以上的加密货币保管于冷钱包中',
  'main.cs24': '24小时客户服务',
  'main.cs24_explain': '通过24小时在线服务窗口迅速地为您解决问题。',
  'main.security': '安全的安保',
  'main.security_explain':
    '通过与韩国最具实力的安保公司S1的业务合作，构建具有完美的安全性金融机构标准的3重安保系统',
  'main.giving_uio': '支付IEXCO货币',
  'main.giving_uio_explain': '按照交易所交易业绩奖励IEXCO货币。',
  'main.with_shoppingmall': '购物商店联动',
  'main.with_shoppingmall_explain':
    '所持现金通过发送可在合作平台（购物网等）中自由使用。',
  'main.mobile_feature_title': '手机交易的最佳化服务',
  'main.mobile_feature_01': '提供可随时随地交易的手机用户专用界面',
  'main.mobile_feature_02': '交易所合作平台货币钱包地址的手机号码化',
  'main.mobile_feature_03': '提供安卓、iOS专用APP(计划开设)',
  'main.go_to_exchange': '查看交易所',
  'main.cash_market': 'USDT市场',
  'trade.order': '购买',
  'trade.orderbook': '出价',
  'trade.marketprice': '市价',
  'trade.chart': '图表',
  'trade.info': '信息',
  'trade.now_price': '现在价格',
  'trade.evaluated_price': '评估金额',
  'trade.change': '变动率(%)',
  'trade.volume': '交易量',
  'trade.yesterday_last_price': '昨日收盘价',
  'trade.today_high': '当日高价',
  'trade.today_low': '当日低价',
  'trade.volume_fiat': '交易费用',
  'trade.high': '高价',
  'trade.low': '低价',
  'trade.holding_coin': '持有货币',
  'trade.coin_name': '货币名称',
  'trade.holding_amount': '持有数量',
  'trade.evaluted_price': '评估金额',
  'trade.coin_info': '货币信息',
  'trade.yesterday_contribution_cash': '昨日奉献度现金',
  'trade.yesterday_contribution_cash_trade': '交易',
  'trade.yesterday_contribution_cash_not_trade': '未交易',
  'trade.paid_contribution_cash': '支付奉献度现金',
  'trade.person_count': '名',
  'trade.holding_uio_coin': '持有IEXCO货币(平均)',
  'trade.recommender_count': '推荐人数',
  'trade.recommender_volume_fiat': '推荐人交易费用',
  'trade.type': '类型',
  'trade.gubun': '区分',
  'trade.time': '时间',
  'trade.ordered_time': '订购时间',
  'trade.price': '价格',
  'trade.amount': '数量',
  'trade.ordered_amount': '订购数量',
  'trade.ordered_price': '订购价格',
  'trade.cancel_select': '取消选择订购',
  'trade.outstanding_amount': '未协议量',
  'trade.confirmed_price_short': '协议价',
  'trade.confirmed_price': '协议价格',
  'trade.confirmed_amount': '协议量',
  'trade.confirmed_amount_cash': '协议金额',
  'trade.confirmed_time': '协议时间',
  'trade.status': '状态',
  'trade.all': '全部',
  'trade.confirming': '协议中',
  'trade.completed': '完成',
  'trade.cancel': '取消',
  'trade.buy': '购买',
  'trade.sell': '出售',
  'trade.realtime_trade_history': '实时协议',
  'trade.outstanding_order': '未协议',
  'trade.confirmed_order': '协议',
  'trade.order_amount': '订购量',
  'trade.orderbook_price': '出价',
  'trade.cancel_all': '一概取消',
  'trade.orderbook_left_amount_sum': '显示总计剩余量',
  'trade.orderable': '可以订购',
  'trade.buy_amount': '购买数量',
  'trade.buy_price': '购买价格',
  'trade.sell_amount': '出售数量',
  'trade.sell_price': '出售价格',
  'trade.charge_cash': 'USDT充值',
  'trade.compare_with_now_price': '比现在价格 %',
  'trade.total_order_price': '总订购金额',
  'trade.max': '最多',
  'trade.can': '可以',
  'trade.order_unitPrice': '出价',
  'trade.min_order_amount_price': '最少订购金额',
  'trade.reset': '初始化',
  'trade.fee': '手续费',
  'trade.today_total_volume': '今日总交易额',
  'trade.yesterday_uio_mining': '昨日IEXCO货币开采',
  'trade.today_minable_amount': '日开采量',
  'trade.today_minable_bonus_amount': '日奖励开采量',
  'trade.total_volume': '总交易金额',
  'trade.my_volume': '本人交易金额',
  'trade.holding_uio_amount_avg': '持有IEXCO数量（平均）',
  'trade.mined_uio_amount': 'IEXCO开采量',
  'trade.recieved_bonus_uio_amount': '奖励IEXCO支付量',
  'trade.total_mined_uio_amount': '总IEXCO开采量',
  'trade.there_is_no_outstanding_orders': '没有未协议的订购。',
  'trade.there_is_no_closed_orders': '没有已协议的订购。',
  'myinvest.funds': '资产记录',
  'myinvest.trade_history': '交易记录',
  'myinvest.outstanding_order': '未协议记录',
  'myinvest.wait_deposit_and_withdraw': '等待存取款',
  'myinvest.myinvest_info':
    '* 平均购买价、评估金额、评估损益、收益率是全部转换为现金的仅供参考的推定值。',
  'myinvest.total_buy': '总购买金额',
  'myinvest.total_evaluate': '总评估金额',
  'myinvest.total_profit': '总评估损益',
  'myinvest.total_profit_rate': '总评估收益率',
  'myinvest.holding_cash': '拥有USDT',
  'myinvest.holding_total_assets': '总拥有资产',
  'myinvest.holding_total_coin': '总货币',
  'myinvest.coin_name': '货币名称',
  'myinvest.holding_amount': '持有数量',
  'myinvest.buy_unit_price_avg': '购买评均价',
  'myinvest.buy_price': '购买金额',
  'myinvest.evaluated_price': '评估金额',
  'myinvest.evaluated_profit_rate': '评估损益(%)',
  'myinvest.order': '订购',
  'myinvest.coin': '货币',
  'myinvest.confirmed_time': '协议时间',
  'myinvest.order_price': '订购价',
  'myinvest.confirmed_amount': '协议量',
  'myinvest.fee': '手续费',
  'myinvest.confirmed_price_avg': '协议价(平均)',
  'myinvest.confirmed_amount_price': '协议总额',
  'myinvest.7d': '7日',
  'myinvest.30d': '30日',
  'myinvest.90d': '90日',
  'myinvest.search': '查找',
  'myinvest.order_time': '订购时间',
  'myinvest.order_amount': '订购量',
  'myinvest.outstanding_amount': '未协议量',
  'myinvest.etc': '备注',
  'myinvest.time': '时间',
  'myinvest.amount': '金额/数量',
  'myinvest.platform': '平台',
  'myinvest.deposit_name': '存款者姓名',
  'myinvest.status': '状态',
  'myinvest.go_to_block_explorer': '交易原账',
  'myinvest.txid': '交易ID',
  'myinvest.deposit_wait': '等待存款',
  'mypage.member_info': '会员信息',
  'mypage.security': '安保认证',
  'mypage.connection_info': '接触信息',
  'mypage.contribution_cash_title': '奉献度USDT支付记录',
  'mypage.contribution_cash_title_short': '奉献度USDT',
  'mypage.uio_mining': 'IEXCO货币开采记录',
  'mypage.uio_mining_short': '开采记录',
  'mypage.recommender': '推荐人',
  'mypage.change_password': '修改密码',
  'mypage.email': '邮箱',
  'mypage.name': '姓名',
  'mypage.phone': '手机',
  'mypage.security_level': '安保等级',
  'mypage.your_trading_fee': '会员的交易手续费(包括增值税)',
  'mypage.cash_markets': 'USDT市场',
  'mypage.event_alram': '接收活动等消息(邮件, SMS)',
  'mypage.event_alram_ok_or_deny': '设置接收或拒收活动消息',
  'mypage.event_alram_explain':
    '※存取款消息的重要通知事项通过邮件发送，与是否同意接收活动消息无关。',
  'mypage.password_condition': '英文小写字母、数字、特殊符号组合为8字以上',
  'mypage.now_password': '现在密码',
  'mypage.new_password': '新密码',
  'mypage.new_password_check': '确认新密码',
  'mypage.level': '标准',
  'mypage.your_level':
    "<span class='name'>{name}</span>您的现在个人安全等级<span class='level'>是标准 {level}</span>。",
  'mypage.your_level_description':
    '现在会员等级 [标准 {level}] 可马上使用交易所。',
  'mypage.next_level_can_easy_deposit':
    '在下一步中通过存取款帐户验证可更方便地使用存取款服务。',
  'mypage.email_verification': '邮件验证',
  'mypage.phone_verification': '本人手机验证',
  'mypage.bank_verification': '帐户验证',
  'mypage.otp_verification': 'OTP验证',
  'mypage.optional': '选择事项',
  'mypage.otp_app_desc': '应设置智能手机 (Android, iOS)谷歌验证App。',
  'mypage.otp_is_optional': '* OTP验证为选择事项。',
  'mypage.set': '设置',
  'mypage.request_reset': '初始化要求',
  'mypage.verify': '验证',
  'mypage.deposit_info': '存款专用帐户信息',
  'mypage.withdraw_info': '取款专用帐户信息',
  'mypage.bank_name': '银行名',
  'mypage.bank_account': '银行帐号',
  'mypage.bank_account_holder': '户名',
  'mypage.deposit': '存款',
  'mypage.request_change_bank_account': '申请修改',
  'mypage.realname_account_check': '实名制存取款服务',
  'mypage.select_bank': '选择银行',
  'mypage.bank_account_placeholder': "请省略'-',只输入数字。",
  'mypage.not_this_bank': ' *地区农协、畜协无法使用',
  'mypage.verify_my_account': '本人帐户验证',
  'mypage.otp_setting': '设置OTP',
  'mypage.otp_code_setting': '设置OTP代码',
  'mypage.otp_with_login': '登录(登录时显示OTP验证)',
  'mypage.otp_with_withdraw': '取款/汇款 (汇款时显示OTP验证)',
  'mypage.verification_code': '验证码',
  'mypage.email_verification_code': '邮箱验证码',
  'mypage.enter_number': '确认',
  'mypage.please_input_otp_verification_code': '输入OTP验证码',
  'mypage.save': '保存',
  'mypage.otp_setting_alert': '※修改设置时请解除复选框后进行。',
  'mypage.otp_delete': '解除OTP设置',
  'mypage.otp_delete_alert':
    '※解除设置时OTP设置被初始化，无法使用现有的OTP，应重新登录OTP。',
  'mypage.connection_info_desc':
    '会员登录记录。如有不是您本人登录的记录时，请立即修改密码并在所有设备中退出登录。',
  'mypage.location': '位置',
  'mypage.device': '机型',
  'mypage.browser': '浏览器',
  'mypage.ip': 'IP',
  'mypage.date': '日期',
  'mypage.contribution_cash_date': '日期',
  'mypage.holding_coin': '持有货币',
  'mypage.holding_coin_state': '持有货币',
  'mypage.volume': '交易费用',
  'mypage.recommender_count': '推荐人数',
  'mypage.recommender_volume': '推荐人交易金额',
  'mypage.contribution_cash': '奉献度USDT',
  'mypage.day': '日',
  'mypage.month': '月',
  'mypage.year': '年',
  'mypage.accumulated_contribution_cash': '累计奉献度现金',
  'mypage.date_range': '时间',
  'mypage.search': '查找',
  'mypage.accumulated_uio_mining': '累计开采货币',
  'mypage.for_mining_volume': '额',
  'mypage.mined_amount': '开采量',
  'mypage.bonus_uio_mined_amount': '奖励IEXCO支付量',
  'mypage.total_uio_mined_amount': '总IEXCO开采量',
  'mypage.mined_unit_price': '开采单价',
  'mypage.mined_uio': 'IEXCO开采量',
  'mypage.no': '号码',
  'mypage.recommend_date': '推荐登录日',
  'mypage.more_withdraw_limit': '更多的取款限度',
  'support.notice': '通知事项',
  'support.guide': '使用指南',
  'support.faq': '常见疑问',
  'support.document_guide': '材料提交说明',
  'support.inquiry': '1:1咨询',
  'support.notice_all': '全部',
  'support.notice_title': '题目',
  'support.notice_content': '内容',
  'support.notice_date': '登录日',
  'support.search': '查找',
  'support.no': '号码',
  'wallet.total_assets': '总拥有资产',
  'wallet.cash_plus_coin': '(USDT+加密货币评估额)',
  'wallet.evaluated_coin': '加密货币评估额',
  'wallet.evaluated_profit': '评估损益',
  'wallet.evaluated_profit_rate': '收益率',
  'wallet.coin_name': '货币名',
  'wallet.holding_pie': '持有比重',
  'wallet.holding_amount': '持有数量(评估金额)',
  'wallet.holding_amount_short': '持有数量',
  'wallet.deposit_and_withdraw': '存取款',
  'wallet.total_cash': '总持有现金',
  'wallet.on_trade_cash': '等待交易',
  'wallet.can_withdraw_cash': '可以取款',
  'wallet.accumulated_mining_coin': '累计开采货币',
  'wallet.airdrop_lock': '隔空投送(Lock)',
  'wallet.evaluated_cash': '现金评估金额',
  'wallet.cash_deposit': 'USDT存款',
  'wallet.cash_withdraw': 'USDT取款',
  'wallet.deposit': '存款',
  'wallet.withdraw': '取款',
  'wallet.cash_history': 'USDT存取款记录',
  'wallet.charge_with_bank_account': '帐户现金充值',
  'wallet.charge_with_platform': '合作平台现金充值',
  'wallet.charge_with_bank_account_desc':
    '※ 请输入下方存款金额，先进行 "存款请求"后，在当日（当日24点）前进行无存折存款。',
  'wallet.deposit_amount': '存款金额',
  'wallet.deposit_amount_placeholder': '请输入存款金额。',
  'wallet.won': '韩元',
  'wallet.deposit_name': '存款者',
  'wallet.request_deposit': '存款请求',
  'wallet.not_yet_verified':
    '还未进行帐户验证，无法通过帐户充值现金。请先进行帐户验证。',
  'wallet.not_yet_verified_withdraw':
    '还未进行帐户验证，无法通过帐户充值现金。请先进行帐户验证。',
  'wallet.cant_withdraw_now': '现在无法取款。详细内容请参考通知事项。',
  'wallet.request_verify_bank_account': '验证帐户',
  'wallet.select_platform': '选择合作平台',
  'wallet.tmoney': 'T-Money',
  'wallet.okcashbag': 'OKCASHBAG',
  'wallet.shopcorn': 'SHOPCORN',
  'wallet.please_use_shopcorn': '该平台的现金充值正在准备中。请使用SHOPCORN。',
  'wallet.go_to_charge_with_platform': '充值',
  'wallet.charge_with_platform_desc':
    '※ 请前往合作网站进行现金充值，并在现金充值后发送至交易所。',
  'wallet.are_you_going_to_shopcorn':
    '可在www.shopcorn.co.kr充值。现在马上前往吗?',
  'wallet.oneday_withdraw_limit': '1日取款限度',
  'wallet.min_withdraw_limit': '最少可取款',
  'wallet.onetime_withdraw_limit': '1次取款额度',
  'wallet.withdraw_to_bank_account': '银行帐户取款',
  'wallet.withdraw_to_platform': '合作平台取款',
  'wallet.can': '可以',
  'wallet.max': '最多',
  'wallet.request_withdraw_cash': '要求取款现金',
  'wallet.can_use': '可以使用',
  'wallet.send_fee': '发送手续费',
  'wallet.please_enter_reciever_phone_num': '输入收款人手机号码',
  'wallet.platform_withdraw_alert':
    '※ 应与注册合作平台会员时使用的电话号码一致才能取款。',
  'wallet.withdraw_bank_account_title': '取款帐户说明',
  'wallet.bank_name': '银行名',
  'wallet.bank_account': '帐号',
  'wallet.bank_account_holder': '户名',
  'wallet.check_otp': 'OTP确认',
  'wallet.hp_verification_for_your_safety':
    '为保障取款的安全，再次进行本人手机验证。',
  'wallet.please_enter_verification_code': '请输入验证码',
  'wallet.get_verification_code': '接收验证码',
  'wallet.check_verification_code': '确认验证码',
  'wallet.request_withdraw': '申请取款',
  'wallet.request_withdraw_short': '申请取款',
  'wallet.deposit_address': '存款地址',
  'wallet.deposit_withdraw_history': '存取款记录',
  'wallet.day': '{day}日',
  'wallet.1d': '1日',
  'wallet.7d': '7日',
  'wallet.30d': '30日',
  'wallet.60d': '60日',
  'wallet.all': '全部',
  'wallet.deposit_history': '存款记录',
  'wallet.withdraw_history': '取款记录',
  'wallet.depositWait_history': '等待存款记录',
  'wallet.airdrop_history': '支付记录',
  'wallet.airdropLock_history': 'Airdrop(Lock)记录',
  'wallet.wait': '等待',
  'wallet.complete': '完成',
  'wallet.request_date': '要求日期',
  'wallet.deposit_cash': '存款现金',
  'wallet.platform_address': '合作网站/帐户',
  'wallet.status': '状态',
  'wallet.withdraw_date': '取款日期',
  'wallet.withdraw_request': '取款请求',
  'wallet.withdraw_complete': '完成取款',
  'wallet.fee': '手续费',
  'wallet.reg_date': '登录日',
  'wallet.content': '内容',
  'wallet.airdrop_cash': '支付USDT',
  'wallet.my_deposit_address': '我的 {coinName} 存款地址(存款专用)',
  'wallet.new_member_must_create_address':
    '新注册会员应点击地址生成按键，生成固有 {coinName} 地址。',
  'wallet.deposit_alert': '存款时注意事项',
  'wallet.you_can_check_last_deposit_withdraw_history_in_history_menu':
    '※ 在交易记录现况页面中可确认存取款历史记录。',
  'wallet.withdraw_fee_desc':
    '每次承担100USDT的取款手续费。在申请的1,000USDT中扣除100USDT的手续费，将900USDT存入登录帐户中。',
  'wallet.copy': '复制',
  'wallet.withdraw_amount': '取款数量',
  'wallet.to_external_address': '发送至钱包地址',
  'wallet.to_internal_member': '发送至手机号(内部会员)',
  'wallet.check_coin_address': '确认取款地址',
  'wallet.withdraw_fee': '取款手续费 (含增值税)',
  'wallet.total_withdraw_amount': '总取款(包括手续费)',
  'wallet.withdraw_alert': '取款时注意事项',
  'footer.link_about_company': '公司介绍',
  'footer.link_notice': '通知事项',
  'footer.link_terms': '使用条约',
  'footer.link_privacy': '个人信息处理方针',
  'footer.link_guide': '使用说明',
  'footer.link_faq': 'FAQ',
  'footer.copyright_line1':
    '法人代表 : 闵书俊 营业执照号码. 678-88-00932 通信销售业申报 : 第2018-首尔江南-00897',
  'footer.copyright_line2': '首尔市江南区太惠兰路14街16（株）CBI平台',
  'footer.cs_account': '账号、使用咨询',
  'footer.cs_pay': '存取款，其他咨询',
  'footer.cs_time':
    '客服中心工作时间: 09:30 ~ 17:30 (午休时间12:00 ~ 13:00) 本公司不进行电话咨询及拜访咨询。',
  'footer.cs_kakaotalk': '24小时kakaotalk咨询',
  'account.find_id': '找回ID',
  'account.find_pw': '找回密码',
  'account.email': '邮箱',
  'account.username': '姓名',
  'account.password': '密码',
  'account.recommender': 'Recommender',
  'account.confirm': '确认密码',
  'common.next': '下一步',
  'alert.please_enter_email': '请输入邮箱。',
  'alert.invalid_email': '此为错误的邮箱格式。',
  'alert.please_enter_password': '请输入密码。',
  'uio_announce.yesterday_announcement': '昨日公告',
  'uio_announce.original_mining': '定量开采货币',
  'uio_announce.level_mining': '标准开采货币',
  'uio_announce.daterange_mining': '持有期间开采货币',
  'mypage.your_level_description_cant':
    "现在会员等级<span className='text-primary'>[按照标准{level}]</span>无法使用交易所>",
  /* 번역 추가본 19.04.01 */
  'trade.iex_announce.platform_volume': '平台交易金额',
  'trade.iex_announce.partner_volume': '会员公司交易金额',
  'trade.iex_announce.holding_iex_amount': '持有IEXCO数量',
  'trade.iex_announce.total_mining_amount': '总开采量',
  'trade.iex_announce.total_iex_contribution_cash': '总IEX奉献度现金',
  'alert.market_comming_soon': '{market}市场正在准备中。',
  'alert.login_success': '欢迎您来到 UNIONEX!',
  'alert.login_failed': '登录已失败。请再次尝试。',
  'alert.sended_findpw_email': '已将临时密码和链接通过邮件发送。请确认邮件。',
  'alert.api_error': '与服务器的通信发生错误。请再次尝试。',
  'findpw.title': '找回密码',
  'findpw.info_message': '已将临时密码发送至登录的邮箱地址。',
  'findpw.change_pw': '修改密码',
  'signin.info_message': '为保护用户信息，请确认交易所地址与如下地址是否一致。',
  'signup.agree_to_terms': '同意使用条约',
  'signup.agree_to_privacy_policy': '同意个人信息处理方针',
  'signup.please_agree_to_terms': '请同意使用条约。',
  'signup.please_agree_to_privacy_policy': '请同意个人信息处理方针。',
  'signup.alert.please_enter_email': '请输入邮箱。',
  'signup.alert.invalid_email': '邮箱格式不正确',
  'signup.alert.please_proceed_email_verification': '请进行邮箱验证。',
  'signup.alert.please_enter_name': '请输入姓名。',
  'signup.alert.please_enter_email_verification_code': '请输入邮箱验证码。',
  'signup.alert.please_enter_password': '请输入密码。',
  'signup.alert.please_enter_password_check': '请输入确认密码。',
  'signup.alert.pw_validation_length': '密码应为8位以上。',
  'signup.alert.pw_validation_combination':
    '密码必须使用英文字母、数字、特殊符号。',
  'signup.alert.pw_and_pwcheck_not_same': '密码与确认密码不一致。',
  'signup.alert.please_check_google_recaptcha': '请证明不是机器人。',
  'signup.alert.signup_success': '已完成会员注册。',
  'signup.alert.please_check_email_verification_code':
    '已发送邮箱验证码。请确认后输入验证码。',
  'signup.alert.email_verification_time_expired':
    '邮箱验证期限已到期。请再次要求邮箱验证码后进行验证。',
  'signup.alert.email_verification_success': '已确认邮箱验证码。',
  'signup.alert.email_verification_code_is_not_matching':
    '验证码错误。请再次确认后输入。',
  'wallet.history.request_date': '请求日期',
  'wallet.history.deposit_name': '存款人名',
  'wallet.history.deposit_cash': '充值USDT',
  'wallet.history.deposit_fiat': '存款额',
  'wallet.history.account': '合作网站/帐户',
  'wallet.history.status': '状态',
  'wallet.history.withdraw_date': '取款日期',
  'wallet.history.withdraw_request': '取款请求',
  'wallet.history.withdraw_is_complete': '完成取款',
  'wallet.history.withdraw_fee': '手续费',
  'wallet.history.withdraw_status': '状态',
  'wallet.history.reg_date': '登录日',
  'wallet.history.content': '内容',
  'wallet.history.airdrop_cash': '支付USDT',
  'wallet.history.airdrop_coin': '支付货币',
  'wallet.history.txid_link': '交易账簿',
  'wallet.history.amount': '数量',
  'wallet.deposit_below_address': '请存款{coin_name}至如下地址。',
  'wallet.generate_deposit_address': '生成{coinName}地址',
  'wallet.deposit_in_maintenance':
    '现在 {coin_symbol} 存款维护中。请稍后使用！',
  'wallet.withdraw_from_exchange_wallet_to_your_wallet':
    '从交易所钱包中取款至会员的外部 {coin_name}钱包{coin_name}中。所有取款经管理者确认后进行。',
  'wallet.i_agree_to_withdraw_warning': '阅读并同意取款说明及注意事项。',
  'wallet.withdraw_address': '取款地址',
  'wallet.withdraw_under_maintanance':
    '现在{coin_symbol}取款维护中。请稍后使用！',
  'trade.market_under_maintance': '现在{market}市场维护中。请稍后使用！',
  'mypage.not_verified': '未验证',
  'mypage.verification_is_processing': '验证进行中...',
  'mypage.refuse_verification': '被拒绝验证',
  'trade.alert.invalid_amount_price': `请输入正确的订购数量及订购金额。`,
  'trade.alert.invalid_order_unit_price': `出价单位不一致。`,
  'trade.alert.invalid_min_cash': `最少可订购的现金是{cash}现金。`,
  'trade.alert.invalid_orderable_amount': `可订购金额不足。`,
  'trade.alert.success_request_cancel_order': '已请求取消未协议订购。',
  /* 19.04.10 */
  'mypage.verified': '验证',
  'mypage.kyc_verification': 'KYC验证',
  'mypage.kyc.verification_type': '识别类型',
  'mypage.kyc.passport': '护照',
  'mypage.kyc.id_card': '身份证',
  'mypage.kyc.driver_card': '驾照',
  'mypage.kyc.name': '姓名',
  'mypage.kyc.first_name': '名',
  'mypage.kyc.last_name': '姓',
  'mypage.kyc.select': '选择',
  'mypage.kyc.mobile_number': '手机号码(Only Number)',
  'mypage.kyc.passport_number': '护照号码',
  'mypage.kyc.id_card_number': '身份证号码',
  'mypage.kyc.driver_card_number': '驾照号码',
  'mypage.kyc.region': '各国家、地区发行文件',
  'mypage.kyc.expire_date': '到期日',
  'mypage.kyc.issue_date': '发行日',
  'mypage.kyc.upload_image': '上传图片',
  'mypage.kyc.upload': '上传',
  'mypage.kyc.modify': '修改',
  'mypage.kyc.delete': '删除',
  'mypage.kyc.country': '国家',
  'mypage.kyc.city': '城市',
  'mypage.kyc.address': '地址',
  'mypage.kyc.postcode': '邮政编码',
  'mypage.kyc.upload_image_example': '图片上传示例',
  'mypage.kyc.upload_image_example_description':
    '选择驾照或身份证的正面，可与备忘录同时上传。请提供手持身份证的照片。在同一图片中应显示{hostname}和今天日期。面部应清晰可见，可清楚地识别身份证的所有详细事项。',
  'mypage.kyc.ok': '完成',
  'mypage.kyc.please_hide_some_number':
    '上传认证照片时，请务必按照示例照片遮住数字部分后发送。',
  'wallet.first_create_deposit_address':
    '请在存款地址窗口中生成货币钱包地址后取款。',
  'mainbanner.buy': '购买',
  'mypage.kyc.please_upload_file_size_below_5mb': '请上传5MB以下的文件。',

  "api_error_code.-3000": "没有足够的信息",
  "api_error_code.-3001": "无法正常处理。 请联系您的管理员。",
  "api_error_code.-3002": "无法加载数据。",
  "api_error_code.-3003": "电子邮件无法发送请联系您的管理员。",
  "api_error_code.-3005": "您的提款请求未成功处理。 请联系您的管理员。",
  "api_error_code.-3006": "登录失败",
  "api_error_code.-3007": "无法获取数据。 请联系您的管理员。",
  "api_error_code.-3008": "无法更新会员信息。 请联系您的管理员。",
  "api_error_code.-3200": "由于成员拥挤，登录暂停一段时间。",
  "api_error_code.-3202": "访问不正确。",
  "api_error_code.-3203": "登录后可用。",
  "api_error_code.-3204": "登录被阻止请通过{cs_tel}与我们联系。",
  "api_error_code.-3300": "请证明你不是机器人。",
  "api_error_code.-3301": "请证明你不是机器人。",
  "api_error_code.-3400": "验证码不正确。 请检查身份验证号码。",
  "api_error_code.-3500": "QR码生成失败。",
  "api_error_code.-3501": "无法创建Google身份验证器。",
  "api_error_code.-3502": "Google身份验证器更新失败",
  "api_error_code.-3503": "无法删除Google身份验证器。",
  "api_error_code.-3504": "没有Google OTP历史记录。",
  "api_error_code.-3505": "无法检索Google身份验证器信息。",
  "api_error_code.-3506": "Google身份验证器密钥不匹配",
  "api_error_code.-3507": "您可以在创建Google身份验证器[LEVEL3]后申请。",
  "api_error_code.-3508": "请输入您的Google身份验证器代码。",
  "api_error_code.-3600": "它无法访问。",
  "api_error_code.-3601": "有效時間已过期。请再次提出要求。",
  "api_error_code.-3602": "密码不匹配。",
  "api_error_code.-3702": "非法请求",
  "api_error_code.-3703": "电子邮件无法发送",
  "api_error_code.-3800": "注册会员不存在。",
  "api_error_code.-3801": "您已经是注册会员。",
  "api_error_code.-3802": "会员资格失败",
  "api_error_code.-3803": "会员信息不符合。",
  "api_error_code.-3804": "密码不匹配。",
  "api_error_code.-3805": "会员公司信息不符。",
  "api_error_code.-3806": "无法更新会员信息。",
  "api_error_code.-3807": "钱包不存在。",
  "api_error_code.-3808": "帐户注册失败。",
  "api_error_code.-3809": "帐户注册失败。",
  "api_error_code.-3810": "等待管理员批准。",
  "api_error_code.-3811": "已获得管理员批准",
  "api_error_code.-3812": "未能提高提款限额。 请联系您的管理员。",
  "api_error_code.-3813": "請完成電子郵件驗證。",
  "api_error_code.-3900": "请继续进行KYC认证。",
  "api_error_code.-3901": "您目前正在等待身份验证。",
  "api_error_code.-3902": "无法申请KYC认证。",
  "api_error_code.-3903": "注册图像。",
  "api_error_code.-3904": "只能上传小于5M的图像文件。",
  "api_error_code.-3905": "文件上传失败。",
  "api_error_code.-4000": "非法请求",
  "api_error_code.-4001": "非法请求",
  "api_error_code.-4002": "非法请求",
  "api_error_code.-4003": "您最多只能有20个挂单。",
  "api_error_code.-4004": "最低订单金额为{price} {market}",
  "api_error_code.-4005": "出价单位为{priceUnit}。请检查单位出价。",
  "api_error_code.-4006": "最低订购数量为{amount} {symbol}",
  "api_error_code.-4007": "자산이 부족합니다.",
  "api_error_code.-4008": "자산이 부족합니다.。",
  "api_error_code.-4009": "您的订单失败了。 请联系您的管理员。",
  "api_error_code.-4010": "您的订单失败了。 请联系您的管理员。",
  "api_error_code.-4011": "订单价格限制在市场价格的50％。",
  "api_error_code.-4012": "订单价格限制在市场价格的50％。",
  "api_error_code.-4013": "市场请求无效",
  "api_error_code.-4014": "这个市场是暂时停顿的。",
  "api_error_code.-4016": "临时购买已经停止。",
  "api_error_code.-4017": "临时卖出已停止。",
  "api_error_code.-4018": "非法请求",
  "api_error_code.-4019": "合同已经完成。",
  "api_error_code.-4020": "您的订单已被取消。",
  "api_error_code.-4021": "订单取消未成功处理。 请联系您的管理员。",
  "api_error_code.-4022": "订单取消未成功处理。 请联系您的管理员。",
  "api_error_code.-4023": "取消处理目前正在进行中。",
  "api_error_code.-4024": "该合同目前正在进行中。",
  "api_error_code.-4025": "The minimum purchase price of {symbol} is {price}{market}.",
  "api_error_code.-4026": "The minimum selling price of {symbol} is {price}{market}.",
  "api_error_code.-4100": "汇率波动，请再试一次。",
  "api_error_code.-4101": "非法请求",
  "api_error_code.-4102": "非法请求",
  "api_error_code.-4103": "首次存款在72小时以后才可取款。",
  "api_error_code.-4104": "存款最低金额小于10,000USDT。",
  "api_error_code.-4105": "有相同金额的存款记录。 您可以在24小时后申请相同金额的款项。",
  "api_error_code.-4106": "您的存款请求注册失败。",
  "api_error_code.-4107": "您的提款已被暂时限制请与您的管理员联系",
  "api_error_code.-4108": "您的钱包暂时无法使用",
  "api_error_code.-4109": "日志信息未注册。",
  "api_error_code.-4110": "请确认最低提款金额。",
  "api_error_code.-4111": "请一次确认最高提款金额。",
  "api_error_code.-4112": "请检查每日最高提款额{unit}。",
  "api_error_code.-4113": "你的余额很低。",
  "api_error_code.-4114": "撤回失败。 请稍后再试。",
  "api_error_code.-4115": "提款申请失败。 请联系管理员。",
  "api_error_code.-4116": "您无法将其发送到您的钱包地址。",
  "api_error_code.-4117": "您一次可以提取的最高金额为{amount} {symbol}。",
  "api_error_code.-4118": "最低订购数量为{amount} {symbol}。",
  "api_error_code.-4119": "不是有效的地址",
  "api_error_code.-4120": "请继续进行KYC认证。",
  "api_error_code.-4121": "您可以在注册提款账户后申请提款。",
  "api_error_code.-4122": "非法请求",
  "api_error_code.-4123": "由于公司情况，停止创建钱包。",
  "api_error_code.-4124": "钱包创建失败了。",
  "api_error_code.-4125": "钱包创建失败了。",
  "api_error_code.-4126": "您的钱包暂时无法使用",
  "api_error_code.-4127": "撤回已被暂停。",
  "api_error_code.-4128": "无法获取数据。",
  "api_error_code.-4129": "无法获得交换信息。",
  "api_error_code.-4130": "无法获取数据。",
  "api_error_code.-4131": "地址检查失败。 请联系您的管理员。",
  "api_error_code.-4132": "这不是可转换的硬币。",
  "api_error_code.-4133": "无效请求",
  "api_error_code.-4134": "最小转换数量为1USDT",
  "api_error_code.-4135": "没有足够的可兑换硬币。",
  "api_error_code.-4136": "无法注册转换请求。请联系您的管理员",
  "api_error_code.-4137": "无法注册转换请求。请联系您的管理员",
  "api_error_code.-4138": "无法注册转换请求。请联系您的管理员",
  "api_error_code.-4139": "创建钱包后请尝试。",
  "api_error_code.-4200": "无法检索资产信息。 请联系您的管理员。",
  "api_error_code.-4300": "",
  "api_error_code.-4301": "",
  "api_error_code.-4302": "",
  "api_error_code.-4303": "",
  "api_error_code.-4304": "",
  "api_error_code.-4305": "",
  "api_error_code.-4306": "",
  "api_error_code.-4307": "",
  "api_error_code.-4308": "",
  "api_error_code.-4309": "",
  "api_error_code.-4310": "",
  "api_error_code.-4311": "",
  "api_error_code.-4312": "",
  "api_error_code.-4313": "",

  'kyc.complete_message':
    '已申请KYC验证。<br />KYC验证需2~4天。<br /><br />验证通过后可在验证中心进行确认。<br />非常感谢！',
  'alert.change_password_completed': '已修改密码，请用新密码登录。',
  'alert.please_enter_temp_password': '请输入临时密码。',
  'mypage.temp_password': '临时密码',
  'alert.otp_check_completed': '已完成OTP验证。',
  'alert.withdraw_request_is_completed': '已完成帐户取款请求。',
  'trade.alert.not_match_amount_and_price': '请输入正确的订购数量和订购金额。',
  'trade.alert.not_match_unit_price': '出价单位不一致。成交价单位为{unitPrice}。',
  'trade.alert.min_orderable_cash_error':
    '最少可订购{market_type}为{min_orderable_cash}{market_type}。',
  'trade.alert.max_orderable_cash_error':
    '最大可订购{market_type}为{max_orderable_cash}{market_type}。',
  'trade.alert.run_out_of_cash': '可订购金额不足。',
  'trade.alert.market_is_under_maintanance':
    '现在 {market}交易维护中。请稍后使用。',
  'trade.confirm_order': '确认订购',
  'alert.market_is_preparing': '{market}交易正在准备中。',
  'alert.cancel_order_completed': '已取消您所申请的未协议订购。',
  'alert.cancel_order_requested': '已取消您所申请的未协议订购。',
  'alert.please_enter_address_to_check': '请输入将要确认地址。',
  'alert.checking_address_is_completed': '已完成取款地址的确认。',
  'alert.please_deposit_cash': '已完成现金存款请求。请存入该帐户。',
  'wallet.please_deposit_cash_desc':
    '请将存款请求的<span class="deposit-money">{deposit_amount}</span>{currency}存入如下帐户中。',
  'wallet.deposit_warning_title': '存款时的注意事项',
  'wallet.deposit_warning_li1': '申请存款后应在当日午夜（24点）前存入。',
  'wallet.deposit_warning_li2':
    '超过当日24点存款时，应以现在日期重新申请存款。',
  'wallet.deposit_warning_li3': '无法连续两次申请相同的金额。',
  'wallet.deposit_warning_li4': '请确认存款帐号和银行后存入。',
  'mypage.otp_activate': '激活OTP',
  'mypage.i_check_about_otp': '已确认',
  'mypage.otp_warning_li1': '请用手机扫描左边的二维码。',
  'mypage.otp_warning_li2': '如初始化OTP，本代码会有所改动。',
  'mypage.otp_warning_li3': '在手机中删除本二维码时，将无法使用。',
  'mypage.alert.otp_warning_check': '请阅读注意事项后确认。',
  'mypage.alert.otp_activation_completed': '已完成OTP的设置。',
  'wallet.deposit_account_registration': '登录存取款帐户',
  'mypage.complete_registration_deposit_account': '已登录存取款帐户。',
  'alert.otp_delete_completed': '已解除OTP的设置。',
  'alert.otp_setting_updated': '已更新OTP的设置。',
  'signup.alert.password_change_completed': '已成功修改密码。',
  'signup.alert.password_change_failed': '密码修改失败。',
  'signin.please_enter_otp_6': '请输入6位数的OTP验证码。',
  'alert.deposit_address_copied': '已复制存款地址。',
  'mypage.cryptocurrency': '加密货币',
  'mypage.authentication_type': '验证方法',
  'mypage.deposit_limit': '存款限度',
  'mypage.withdrawal_limit': '取款限度',
  'mypage.unlimited': '无限',
  'mypage.once': '1次',
  'mypage.by_oneday': '1天',
  'guide.main_title': '使用介绍',
  'guide.platform_title': '存取款使用介绍',
  'guide.trade_title': '交易使用介绍',
  'guide.cash_market': 'USDT市场',
  'guide.market_gubun': '市场区分',
  'guide.gubun': '区分',
  'guide.content': '内容',
  'guide.cash_market_desc': '可用USDT买卖加密货币。',
  'guide.day_trade_data_standard': '每日交易数据标准',
  'guide.day_trade_data_standard_desc':
    '按照UTC(协调世界时)标准计算每日数据。大多数的国际交易所使用UTC标准时间，易于比较海外市价。UTC比韩国时间(KST)慢9小时。',
  'guide.updown_yesterday': '对比昨日涨跌率',
  'guide.updown_yesterday_desc':
    'UTC标准0点(韩国时间上午9点)收盘价对比当日收盘价（或现在价格）涨跌率 ',
  'guide.trade_volume': '交易量(24H)',
  'guide.trade_volume_desc': '近期24小时期间的累计交易量',
  'guide.candle_day': '每日K线图',
  'guide.candle_day_desc':
    '从UTC标准0点起24小时（或现在时刻）期间的市价、高价、低价、收盘价 ',
  'guide.trade_fee_standard': '交易手续费标准',
  'guide.trade_fee_standard_desc1':
    '交易手续费计算方式: 协议金额(订购数量X订购价格) X 交易手续费率(%)',
  'guide.trade_fee_standard_desc2': '交易手续费显示至第2位小数。',
  'guide.trade_fee_method': '交易手续费结算方式',
  'guide.trade_fee_method_desc1':
    '出售订购时结算金额=协议金额(订购数量X订购价格) + 交易手续费',
  'guide.trade_fee_method_desc2':
    '订购订购时结算金额= 协议金额(订购数量X订购价格) – 交易手续费',
  'guide.min_orderable_price_and_unit_price': '最少订购单位 & 出价单位',
  'guide.min_orderable_price': '最少订购单位',
  'guide.unit_price': '出价单位',
  'guide.deposit_fee': '存款手续费',
  'guide.withdrawal_fee': '取款手续费',
  'guide.no_charge': '免费',
  'guide.dw_support_title': '支持存取款货币',
  'guide.level_guide_title': '各安保等级的每日存取款限度',
  'guide.dw_fee_guide_title': '存取款手续费(包括增值税)',
  'guide.dw_fee_guide_desc1': '现金转换后前往至菜单平台，可兑换或使用。',
  'guide.dw_fee_guide_desc2':
    '上述手续费政策依照使用条约第25条可跟随市场状况变动，无需事先通知。',
  'guide.unionex_mining_title': '开采跟随交易金额的变化而变化',
  'guide.mining_range': '开采区段',
  'guide.mining_coin_cnt': '发行货币数',
  'guide.mining_volume': '交易金额(USDT)',
  'socket_api_code.202': '{od_temp_coin} {currency} 完成出售订购',
  'socket_api_code.204': '{od_temp_coin} {currency} 完成购买订购',
  'socket_api_code.206': '{currency} 已取消出售订购。 ',
  'socket_api_code.208': '{currency} 已取消购买订购',
  'socket_api_code.210': '已协议{currency} {od_temp_coin}个。',
  'otp.remove': '移走',
  'otp.verification_pending': '待决...',
  'home.m.title': '针对移动交易进行了优化',
  'home.m.desc': '提供随时随地都可以交易的手机专用UI',
  'home.about.t1': '世界上第一个会员协会。 共享平台',
  'home.about.d1':
    '全球交流联合为一体，提供多语言支持，全球用户共享',
  'home.about.t2': '平台收入份额。 分配',
  'home.about.d2': '与会员公司和USER分享平台收入。',
  'home.about.t3': '客户支持',
  'home.about.d3':
    '及时处理用户投诉和多语言服务',
  'home.about.t4': '保安及稳定性',
  'home.about.d4': '完善的保护系统，可抵御DDoS和XSS等攻击，通过“cold storage”保护客户资产，并提供24小时存取监控',
  'security.your_level.lv1':
    '现在会员等级[LV1]可立即使用交易所。通过下一步的KYC认证激活本人认证与货币取款。',
  'security.your_level.lv2':
    '已完成现在等级[LV2]的本人认证。通过下一步的OTP认证可加强保安，且可存取更多的货币。',
  'security.your_level.lv3':
    '已完成现在等级[LV3]的OTP认证。',
  'security.your_level.lv4': '已完成现在等级[LV4]更多取款额度的申请。',
  'security.level4.desc':
    '如果您要求提款限额增加，经理会根据您的交易业绩和贡献提高水平。',
  'security.level4.request': '要求增加提款限额',
  'security.level4.pending': '处理...',
  'security.level4.desc_success':
    '您的提高取款额度申请已通过。',
  'security.level4.desc_failed':
    '您的提高取款额度申请被驳回。需要更多的交易业绩。',
  'alert.request_lv4_success':
    '成功的提款限额请求。 请等待管理员确认',
  'coinInfo.summary': '概要',
  'coinInfo.about': '介紹',
  'alert.bank_verification.no_kyc': 'KYC认证后可使用。',
  'alert.do_you_want_to_log_out': '你想登记吗?',
  'wallet.minimum_withdraw_amount': '最低出纳金额',
  'wallet.withdraw_account_info': '出纳账户通知',
  'trade.favorite': '收藏夹',
  'required': '必须',
  'all_is_required': '所有项目都是必须输入的事项。',
  'txid': 'txid',
  'alert.you_can_search_max_three_month': '您最多可以查看3个月。',
  'trade.hours': '小时',
  'myinvest.you_have_no_coin': '无保留硬币。',
  'wallet.history.od_status.CAN': '取消',
  'wallet.history.od_status.OK': '完成',
  'wallet.history.od_status.REQ': '待机',
  'wallet.history.od_status.WAIT': '待机',
  'wallet.history.od_status.REJ': '拒绝',
  'wallet.history.od_status.HOLD': '停歇',
  'wallet.history.od_status.PROC': '处理中',
  'alert.please_verify_otp_code': '请进行OTP认证。',
  'alert.min_deposit_up_is': '※ 最低汇款金额为{min_deposit}USDT。',
  'alert.min_deposit_usdt': '最低汇款金额',
  'notice.hq': '全部通知',
  'bankaccount.desc': '无论银行如何，提款账户只能注册一个他/她自己姓名的账户。',
  'wallet.convert': '转换',
  'wallet.convert_coin': '转换硬币',
  'wallet.convert_history': '转化历史',
  'wallet.convertable_coin': '可转换硬币',
  'wallet.lets_convert_coin': '将硬币转换为USDT硬币',
  'wallet.alert.only_btc_and_eth_is_convertable': '只有BTC和ETH硬币可以兑换成USDT硬币。',
  'wallet.convert_amount': '转换数量',
  'wallet.usdt_amount': 'USDT数量',
  'wallet.select_coin': '选择硬币',
  'wallet.request_convert': '轉換',
  'wallet.check_below_before_convert_usdt': '你想转换硬币如下吗？',
  'wallet.coin_convert_done': '硬币转换完成。',
  'alert.first_login': '预注册完成。通过在比赛期间登录可以找到模拟投资的“8,000 USDT”。',
  'kyc.rejected': 'KYC认证被拒绝。 请再次进行！',
  'trade.today_volume': '今日贸易额',
  'trade.yesterday_volume': '昨天贸易额',
  'kyc.rejected_type_0': 'KYC认证被拒绝。 请再次进行！',
  'kyc.rejected_type_1': '请上传带有ID拍摄的照片。',
  'kyc.rejected_type_2': '我无法验证您的身份。',
  'kyc.rejected_type_3': '分别输入您的名字和姓氏',
  'kyc.rejected_type_4': '等 - 请联系客服！',
  'kyc.rejected_type_5': '메모 내용이 누락되었거나 정확하지 않습니다. (내용 : URL, 오늘 날짜)',
  'kyc.check_rejected_msg': '거절사유 보기',
  'wallet.history.airdrop_date': '付款日期',
  'wallet.history.airdrop_type': '师',
  'wallet.history.airdrop_amount': '付款数量（LOCK）',
  'wallet.history.airdrop_release_lock': '下达开始',
  'wallet.history.airdrop_release_lock_period': '下达周期',
  'wallet.history.airdrop_release_lock_amount': '下达数量',
  'wallet.history.is_mining': '开采',
  'wallet.alert.convert_price_is_on_cmc': '※ USDT转换的基本价格基于CoinMarketCap。',
  'home.about.guide.platform.title': "Operations Policy",
  'home.about.guide.platform.desc': `<li>A general outline</li>
  <li>UNIEX Platform coin</li>
  <li>Distribution of profits</li>
  <li>User's deposit withdrawal procedure</li>
  <li>Deposit withdrawal support limits for deposits by security grade of money and users.</li>`,
  'home.about.guide.trade.title': "Information on the use of coin transactions",
  'home.about.guide.trade.desc': `<li>Market classification</li>
  <li>Criteria for Daily Transaction Data</li>
  <li>Criteria for calculation and settlement of fees</li>
  <li>Minumum Order unit and Price Unit</li>
  <li>Coin deposit withdrawal fee</li>`,
  'home.about.guide.download.title': "Download",
  'home.about.guide.download.warning_for_investor': "Investor Precautions",
  'home.about.guide.download.fraud_guide': "A financial fraud guide",
  'home.about.guide.download.deposit_error': "Handling coin deposit errors",
  'wallet.withdraw_dest_tag': 'Destination Tag',
  'wallet.my_deposit_dest_tag': 'My Destination Tag',
  'alert.deposit_dest_tag_copied': 'Destination tag is copied.',
  'wallet.staking_history': 'Staking History',
  'wallet.history.coin_amount': "Coin Amount",
  'wallet.history.release_staking_start_date': "Staking Date",
  'wallet.history.release_staking_end_date': "De-staking Date",
  'mypage.cancel_account': '结束帐户通知书',
  'mypage.cancel_account.step1.title': '会员退出通知',
  'mypage.cancel_account.step1.desc': '请阅读脱离会员注意事项',
  'mypage.cancel_account.step2.title': '查核所持有的资产',
  'mypage.cancel_account.step2.desc': '检查你的资产 提取存款',
  'mypage.cancel_account.step3.title': '会员退出申请书',
  'mypage.cancel_account.step3.desc': '请准确填写退出会员申请书',
  'mypage.cancel_account.step4.title': '会员退出申请完成',
  'mypage.cancel_account.step4.desc': '会员退出申请已完成 确认后完成处理',
  'mypage.cancel_account.step1.body_title': '确认退出会员注意事项',
  'mypage.cancel_account.step1.body_desc': '1. 确认拥有资产<br />2. 节余出禁<br />3. 会员退出后所有资料都将被删除。 无法修复<br />4. 退出会员前请重新确认注意事项',
  'mypage.cancel_account.step2.body_title': '查核所持有的资产',
  'mypage.cancel_account.step2.body_desc': '1. 请务必确认剩余本人资产<br />2. 退出会员之前请先出钱<br />3. 注销会员后,所有资料无法修复',
  'mypage.cancel_account.step3.body_title': '填写退出会员申请书',
  'mypage.cancel_account.step3.body_desc': '[ 填写退出会员申请书时的注意事项 ]<br />1. 身份证,驾驶证,护照中选择1种<br />2. 如示附上身份证和本人相片文件<br />3. 身份证上的照片和内容可以识别,身份证照片和本 人照片必须一致',
  'mypage.cancel_account.step4.body_title': '会员退出申请完成',
  'mypage.cancel_account.step4.body_desc': '会员退出处理以营业日为准需要2~3天<br />谢谢你利用我',
  'mypage.cancel_account.next': '下一页',
  'mypage.cancel_account.go_to_write_form': '填写申请书',
  'mypage.cancel_account.ok': '确认',
  'mypage.cancel_account.please_write_form_first': '请先填写申请表。',
};
